import { DateTime as DT } from 'luxon';
import { UserNameItem } from 'modules/user';
import { formatPrice } from 'utils/helpers/functions/formatPrice';
import { withBaseCurrency, withLocalCurrency } from 'utils/helpers/currency/currencyHelpers';
import type { HistoryPriceRow } from './model';
import SolarIcon from 'components/icons/SolarIcon';

interface HistoryPriceTableRowProps {
    row: HistoryPriceRow;
    isUahMode: boolean;
}

const formatMoney = (amount: number, isUah: boolean) =>
    isUah ? withLocalCurrency(formatPrice(amount)) : withBaseCurrency(formatPrice(amount));

const HistoryPriceTableRow = ({ row, isUahMode }: HistoryPriceTableRowProps) => {
    const date = DT.fromMillis(row?.dt || 0).toFormat('dd.MM.yyyy');
    const time = DT.fromMillis(row?.dt || 0).toFormat('HH:mm');
    const oldPrice = Number(row?.oldPrice || 0);
    const newPrice = Number(row?.newPrice || 0);
    const direction =
        newPrice > oldPrice ? 'up' : newPrice < oldPrice ? 'down' : 'same';

    return (
        <tr>
            <td className="username">
                <UserNameItem
                    user={{
                        userName: row.userName,
                        userEmail: row.userEmail,
                        userPicture: row.userPicture || undefined,
                    }}
                />
            </td>
            <td className="date">
                <span className="d-block">{date}</span>
                <span className="d-block text-muted fs-12">{time}</span>
            </td>
            <td className="change">
                <div className={`history-price-change history-price-change--${direction}`}>
                    <span className="history-price-change__old">
                        {formatMoney(oldPrice, isUahMode)}
                    </span>
                    <SolarIcon name="arrow-right" className="history-price-change__arrow" aria-hidden="true" />
                    <span className="history-price-change__new">
                        {formatMoney(newPrice, isUahMode)}
                    </span>
                </div>
            </td>
            <td className="comment">
                {row.comment ? (
                    <span className="history-price-comment">{row.comment}</span>
                ) : (
                    <span className="text-muted">—</span>
                )}
            </td>
        </tr>
    );
};

export default HistoryPriceTableRow;
